<template>
<div class="chapter">
<div class="inner_page">
<p class="fm2"><a id="page_4"></a>The Author’s stories have appeared also in periodicals and anthologies as indicated:</p>
<p class="fm1">“Usher.”<em class="italic">Commentary,</em> Feb. 1956.</p>
<p class="fm1">“The Penny Is for God!” <em class="italic">The Chicago Jewish Forum.</em> Sept. 1965.</p>
<p class="fm1">“Tessie, Don’t Give Away the Raisin; without It, You’re Lost!” <em class="italic">Brooklyn Literary Review,</em> No. 5, 1984.</p>
<p class="fm1">“Free the Canaries from Their Cages!” <em class="italic">Commentary,</em> Sept. 1955; <em class="italic">The Best American Short Stories of 1956,</em> edited by Martha Foley (Boston: Houghton Mifflin Company, 1956); <em class="italic">Prize Stories of 1957</em> (The O’Henry Memorial Awards), edited by Paul Engle and Constance Urdang (Garden City, N.Y.: Doubleday and Company, Inc., 1957).</p>
<p class="fm1">“No Golden Tombstones for Me!” <em class="italic">Commentary,</em> Nov. 1956.</p>
<p class="fm1">“They’re Killing Jews on Sackman Street!” <em class="italic">Midstream,</em> Autumn 1956; <em class="italic">The Chosen,</em> edited by Harold U. Ribalow(London, New York: Abelard-Schuman, Ltd., 1959); <em class="italic">The Midstream Anthology</em> edited by Shlomo Katz, (New York, London: Thomas Yoseloff. I960).</p>
<p class="fm1">“Fire Is Burning on Our Street!” <em class="italic">Midstream,</em> Sept. 1964.</p>
<p class="fm1">“Come into the Hallway, for Five Cents!” <em class="italic">Commentary,</em> July 1960; <em class="italic">My Name Aloud,</em> edited by Harold U. Ribalow, Thomas Yoseloff (New York. London. 1969).</p>
<p class="fm1">“Hello. Lenin! Hello. Stalin! How’s the Revolution Today?” <em class="italic">The National Jewish Monthly,</em> March 1974.</p>
<p class="fm1">“Songs My Mother Taught Me That Are Not in <em class="italic">Hamlet;</em> or, ‘Come into My House, Horatio! There Are More Things under the Mattress than Are Dreamt of in Your Philosophy!” <em class="italic">Brooklyn Literary Review,</em> No. 4, 1983.</p>
<p class="fm1">“I Went to the Market Place to See the World! Oy, Mama, Oy!” <em class="italic">The Mizrachi Woman,</em> May 1969.</p>
<p class="fm1">“With a Herring in One Hand and a Bottle of Schnapps in the Other; Oh! How He Did Dance!” <em class="italic">Brooklyn Literary Review,</em> No. 6, 1984.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_FrontMatter.vue?7624ac07